import apiFetcher, { apiFetcherArgs } from '@/api/apiFetcher';
import useSWR from 'swr';

export default function useApi<T>(
  args: apiFetcherArgs
): [T | undefined, Error | undefined, boolean] {
  const { data, error, isLoading } = useSWR<T, Error, apiFetcherArgs>(
    args,
    apiFetcher,
    { keepPreviousData: true }
  );
  return [data, error, isLoading];
}
